import React, { useCallback, useEffect, useState, useContext } from "react";
import { axios_instance } from "../../../api/axios_instance";
import ReactDOM from "react-dom";
import { toast } from "react-toastify";
import { DetailPageLoadingModalContext } from "../../../ContextAPI/context";

const CaseInfoConfirmationModal = ({
  toggleCaseConfirmModal,
  finance_lead_id,
  fetchCaseDetails,
}) => {
  const [infoData, setInfoData] = useState({
    downloadInfo: {},
    uploadInfo: {},
  });

  const { setShowLoadingModal } = useContext(DetailPageLoadingModalContext);

  const [disabled, setDisabled] = useState(true);
  const [diffChecker, setDiffChecker] = useState({});

  const fetchCaseData = useCallback(async () => {
    try {
      const response = await axios_instance({
        url: "/dts/getCaseInfoLogData",
        method: "POST",
        data: {
          finance_lead_id,
        },
      });

      if (response.status === 200) {
        const obj = {};

        const currentData = response.data.downloadInfo;
        const uploadData = response.data.uploadInfo;

        Object.keys(uploadData).forEach((key) => {
          if (key !== "tranche") {
            if (currentData[key] !== uploadData[key]) {
              obj[key] = false;
            }
          } else {
            for (const tranche_count in currentData.tranche) {
              const currentTranche = currentData.tranche[tranche_count];
              const uploadTranche = uploadData.tranche[tranche_count];

              for (const tranche_key in currentTranche) {
                if (
                  currentTranche[tranche_key] !== uploadTranche[tranche_key]
                ) {
                  obj[`tranche_${tranche_count}_${tranche_key}`] = false;
                }
              }
            }
          }
        });

        setDiffChecker(obj);

        setInfoData({
          downloadInfo: response.data.downloadInfo,
          uploadInfo: response.data.uploadInfo,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }, [finance_lead_id]);

  useEffect(() => {
    if (!Object.keys(diffChecker).length) {
      setDisabled(true);
      return;
    }

    for (const key in diffChecker) {
      if (!diffChecker[key]) {
        setDisabled(true);
        return;
      }
    }

    setDisabled(false);
  }, [diffChecker]);

  const updateCase = async () => {
    setShowLoadingModal(true);
    try {
      const response = await axios_instance({
        url: "/dts/updateCase",
        method: "POST",
        data: {
          finance_lead_id,
        },
      });

      if (response.status === 200) {
        toast.dismiss();
        toast.success(response.data.msg);
        fetchCaseDetails();

        toggleCaseConfirmModal();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setShowLoadingModal(false);
    }
  };

  useEffect(() => {
    fetchCaseData();
  }, [fetchCaseData]);

  const handleCheck = (key, val) => {
    setDiffChecker({ ...diffChecker, [key]: !diffChecker[key] });
  };

  console.log(diffChecker);

  return ReactDOM.createPortal(
    <div className="modal-wrapper" id="modal-wrapper">
      <div className="updatecaseinfo-modal-content">
        <div className="modal-header">
          <button
            type="button"
            className="close"
            onClick={toggleCaseConfirmModal}
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 className="modal-title" id="">
            Confirm Changes
          </h4>
        </div>
        <div className="modal-body clearfix doc-upload-wrapper">
          <div className="confirm-changes">
            <div class="row form-group">
              <div class="col-sm-5">
                <strong>Loan ID : {finance_lead_id}</strong>
              </div>
            </div>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th colspan="4">Disbursement Details</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td></td>
                  <td>
                    <strong>Current</strong>
                  </td>
                  <td>
                    <strong>New</strong>
                  </td>
                  <td>
                    <strong></strong>
                  </td>
                </tr>
                {Object.keys(infoData.downloadInfo).map((key) => {
                  const currentData = infoData.downloadInfo[key];
                  const uploadData = infoData.uploadInfo[key];

                  if (key !== "tranche") {
                    return (
                      <tr>
                        {key === "Net Disbursement Amount" ? (
                          <td>
                            <strong>{key}</strong>
                          </td>
                        ) : (
                          <td>{key}</td>
                        )}
                        <td>{currentData}</td>
                        <td
                          className={
                            diffChecker.hasOwnProperty(key) && "changes-found"
                          }
                        >
                          {uploadData}
                        </td>
                        <td>
                          {diffChecker.hasOwnProperty(key) && (
                            <input
                              type="checkbox"
                              className="confirm-checkbox"
                              value={diffChecker[key]}
                              onChange={(e) => handleCheck(key, e.target.value)}
                            />
                          )}
                        </td>
                      </tr>
                    );
                  } else return <></>;
                })}
              </tbody>
            </table>

            {infoData.downloadInfo.tranche &&
              Object.keys(infoData.downloadInfo.tranche).map((key) => {
                const trancheData = infoData.downloadInfo.tranche[key];

                return (
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th colspan="4">Tranche {key}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td></td>
                        <td>
                          <strong>Current</strong>
                        </td>
                        <td>
                          <strong>New</strong>
                        </td>
                        <td>
                          <strong></strong>
                        </td>
                      </tr>
                      {Object.keys(trancheData).map((t_key) => {
                        const currentTrancheData =
                          infoData.downloadInfo.tranche[key][t_key];

                        const newTrancheData =
                          infoData.uploadInfo.tranche[key][t_key];

                        return (
                          <tr>
                            <td>{t_key}</td>
                            <td>{currentTrancheData}</td>
                            <td
                              className={
                                diffChecker.hasOwnProperty(
                                  `tranche_${key}_${t_key}`
                                ) && "changes-found"
                              }
                            >
                              {newTrancheData}
                            </td>
                            <td>
                              {diffChecker.hasOwnProperty(
                                `tranche_${key}_${t_key}`
                              ) && (
                                <input
                                  type="checkbox"
                                  className="confirm-checkbox"
                                  value={diffChecker[`tranche_${key}_${t_key}`]}
                                  onChange={() =>
                                    handleCheck(`tranche_${key}_${t_key}`)
                                  }
                                />
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                );
              })}
          </div>
        </div>
        <div class="modal-footer txt-right" id="abc">
          <button
            type="button"
            data-dismiss="modal"
            class="btn rc-btn_default btn-lg"
            onClick={toggleCaseConfirmModal}
          >
            Cancel
          </button>
          <button
            id="confirmCaseInfoBtn"
            type="button"
            class="btn rc-btn_primary btn-lg"
            disabled={disabled}
            onClick={updateCase}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default CaseInfoConfirmationModal;
